import React from "react";

const SvgInstagram = ({ color, ...props }) => (
  <svg width="14" viewBox="0 0 14.031 14" {...props}>
    <path
      d="M4.677 7.01a2.322 2.322 0 1 1 2.322 2.31 2.322 2.322 0 0 1-2.322-2.31m-1.255 0a3.577 3.577 0 1 0 3.577-3.57 3.574 3.574 0 0 0-3.577 3.57m6.46-3.71a.836.836 0 1 0 1.672 0 .836.836 0 0 0-1.672 0m-5.7 9.36a3.708 3.708 0 0 1-1.293-.24 2.278 2.278 0 0 1-1.323-1.31c-.414-1.06-.276-6.09-.239-6.91a3 3 0 0 1 .76-2.09c.7-.69 1.6-1.03 7.725-.75a2.961 2.961 0 0 1 2.1.75c.7.7 1.042 1.61.761 7.71a3.92 3.92 0 0 1-.24 1.29c-.63 1.61-2.08 1.83-8.246 1.55M4.13.11A3.853 3.853 0 0 0 .078 4.15c-.033.7-.22 6.01.323 7.41a3.539 3.539 0 0 0 2.038 2.03 5.079 5.079 0 0 0 1.691.32c6.2.28 8.5.13 9.473-2.35a5.084 5.084 0 0 0 .323-1.69c.283-6.21-.046-7.56-1.127-8.64C11.941.37 10.933-.21 4.13.11"
      fill={color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgInstagram;
